import api from '../config/api';
import type { User, LoginPayload, LoginResponse } from '../types';

export async function loginUser(payload: LoginPayload): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/api/auth/login', {
    username: payload.username,
    password: payload.password,
    captcha_token: payload.captcha_token || undefined,
  });
  return data;
}

export async function fetchCurrentUser(): Promise<User> {
  const { data } = await api.get<User>('/api/auth/me');
  return data;
}

export async function logoutUser(reason: string = 'manual'): Promise<void> {
  await api.post('/api/auth/logout', { logout_reason: reason });
}

export async function updateProfile(payload: Partial<User>): Promise<User> {
  const { data } = await api.put<User>('/api/auth/profile', payload);
  return data;
}

// ── Password Change (Prompt #52) ──
export async function changePassword(currentPassword: string | null, newPassword: string): Promise<{ message: string }> {
  const { data } = await api.post<{ message: string }>('/api/auth/change-password', {
    current_password: currentPassword || undefined,
    new_password: newPassword,
  });
  return data;
}

// ── Password Reset Flow (Prompt #52) ──
export async function forgotPassword(email: string): Promise<{ message: string }> {
  const { data } = await api.post<{ message: string }>('/api/auth/forgot-password', { email });
  return data;
}

export async function verifyResetOtp(email: string, otp: string): Promise<{ reset_token: string; message: string }> {
  const { data } = await api.post<{ reset_token: string; message: string }>('/api/auth/verify-reset-otp', { email, otp });
  return data;
}

export async function resetPassword(resetToken: string, newPassword: string): Promise<{ message: string }> {
  const { data } = await api.post<{ message: string }>('/api/auth/reset-password', {
    reset_token: resetToken,
    new_password: newPassword,
  });
  return data;
}

// ── CAPTCHA Config (Prompt #52) ──
export interface CaptchaConfig {
  enabled: boolean;
  provider: string;
  site_key: string;
}

export async function getCaptchaConfig(): Promise<CaptchaConfig> {
  const { data } = await api.get<CaptchaConfig>('/api/auth/captcha-config');
  return data;
}
